// @flow
import React from 'react';
import styled from 'styled-components';

import { colors } from '../../shared/styles';
import logo from '../../images/logo.svg';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 20px;
    text-align: center;
    background: ${colors.white};
    color: ${colors.grey.default};
`;

const Logo = styled.img`
    width: 260px;
    max-width: 80%;
    margin-bottom: 40px;
`;

const Heading = styled.h1`
    font-weight: lighter;
    font-size: 28px;
    margin: 0 0 16px 0;
    color: ${colors.blue};
`;

const Message = styled.p`
    font-size: 16px;
    line-height: 1.5;
    max-width: 520px;
    margin: 0;
    color: ${colors.grey.light};
`;

const Rule = styled.span`
    display: block;
    width: 60px;
    height: 4px;
    margin: 28px auto 0 auto;
    border-radius: 2px;
    background: ${colors.orange.default};
`;

const DEFAULT_MESSAGE =
    'The Property Management portal is temporarily unavailable while we carry out scheduled maintenance. Please check back again shortly.';

const Maintenance = () => {
    const message =
        process.env.REACT_APP_MAINTENANCE_MESSAGE || DEFAULT_MESSAGE;

    return (
        <Wrapper>
            <Logo src={logo} alt="Network Rail" />
            <Heading>We&rsquo;ll be back soon</Heading>
            <Message>
                {message}
            </Message>
            <Rule />
        </Wrapper>
    );
};

export default Maintenance;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Maintenance.js